module.exports = __webpack_public_path__ + "fonts/349744a.ttf";